export enum Languages {
  DE = 'de',
  PL = 'pl',
  EN = 'en',
}
